import React from "react";

const HistoryIcon = ({
  width = "17",
  height = "17",
  viewBox = "0 0 17 17",
  fill = "#8F8F8F",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block' }}
    {...props}
  >
    <path
      d="M2.06055 2.38232V4.95808H4.63632"
      stroke={fill}
      strokeWidth="1.41667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.41602 8.49947C1.41602 12.4115 4.58733 15.5828 8.49935 15.5828C12.4114 15.5828 15.5827 12.4115 15.5827 8.49947C15.5827 4.58745 12.4114 1.41614 8.49935 1.41614C5.87781 1.41614 3.58886 2.84028 2.36404 4.95713"
      stroke={fill}
      strokeWidth="1.41667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.50238 4.25L8.50195 8.50312L11.5051 11.5062"
      stroke={fill}
      strokeWidth="1.41667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default HistoryIcon;
